import { service } from '@/utils/request'

const prefix = '/cloud/statistic'
// 用户行为数据
export const userApi = {
  getList(data) {
    return service({
      url: prefix + '/census/doctor/behavior',
      method: 'post',
      data
    })
  },
  exportExcel(data) {
    return service({
      url: prefix + '/census/doctor/behavior/export',
      method: 'post',
      data,
      responseType: 'blob'
    })
  }
}
// 教师数据
export const teacherApi = {
  getTeacherDetail(data) {
    return service({
      url: prefix + '/census/teacher/detail',
      method: 'post',
      data
    })
  },
  exportExcel(data) {
    return service({
      url: prefix + '/census/teacher/detail/export',
      method: 'post',
      data,
      responseType: 'blob'
    })
  }
}
// 医院数据
export const hospitalApi = {
  getDetail(data) {
    return service({
      url: prefix + '/census/hospital/detail',
      method: 'post',
      data
    })
  },
  exportExcel(data) {
    return service({
      url: prefix + '/census/hospital/detail/export',
      method: 'post',
      data,
      responseType: 'blob'
    })
  }
}
// 用户行为数据看板
export const userBoardApi = {
  // 统计
  getCount(params) {
    return service({
      url: prefix + '/census/doctor/first',
      method: 'get',
      params
    })
  },
  // 平台活跃
  getActivity(params) {
    return service({
      url: prefix + '/census/doctor/line/active',
      method: 'get',
      params
    })
  },
  // APP活跃
  getAppActivity(params) {
    return service({
      url: prefix + '/census/doctor/line/active/app',
      method: 'get',
      params
    })
  },
  // 平台新增
  getYearNew(params) {
    return service({
      url: prefix + '/census/doctor/line/user/add',
      method: 'get',
      params
    })
  },
  // 漏斗
  getFunnel(params) {
    return service({
      url: prefix + '/census/doctor/funnel',
      method: 'get',
      params
    })
  },
  // 年卡会员活跃
  getSuperActive(data) {
    return service({
      url: prefix + '/census/yc/active',
      method: 'post',
      data
    })
  },
  // 年卡会员活跃
  getSuperRenew(data) {
    return service({
      url: prefix + '/census/yc/renew',
      method: 'post',
      data
    })
  },
  exportSuperActive(data) {
    return service({
      url: prefix + '/census/yc/active/export',
      method: 'post',
      data,
      responseType: 'blob'
    })
  },
  exportSuperCensus(data) {
    return service({
      url: prefix + '/census/yc/renew/export',
      method: 'post',
      data,
      responseType: 'blob'
    })
  },
}
// 医院数据看板
export const hospitalBoardApi = {
  getMapData(params) {
    return service({
      url: prefix + '/census/hospital/map',
      method: 'get',
      params
    })
  },
  getGradesData(data) {
    return service({
      url: prefix + '/census/hospital/grades',
      method: 'post',
      data
    })
  },
  getJobTitleData(data) {
    return service({
      url: prefix + '/census/hospital/jobTitles',
      method: 'post',
      data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/databaseAnlysis/dataAnalysis.js